import StyledLink from "../StyledLink/StyledLink.jsx";
import { string } from "prop-types";

const propTypes = {
  href: string.isRequired,
  target: string,
  text: string.isRequired,
};

const AdItem = (props) => {
  const { href, target, text } = props;

  return (
    <div className="ad-item">
      <div className="ad-item__wrapper">
        <StyledLink className="ad-item__link h4" href={href} target={target}>
          {text}
        </StyledLink>
      </div>
    </div>
  );
};

AdItem.propTypes = propTypes;
export default AdItem;
